import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Input, Label, Form, FormFeedback } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import InputCustom from "../../components/Common/InputCustom";
import { getTypeProperties, getAreas,  
    setPropertySaved, updateProperty as onUpdateProperty, 
    actionGetTypePropertiesSelect} from "store/actions";
import SelectCustom from "components/Common/SelectCustom";
import { isNull } from "lodash";


const FormNewProperty = props => {

    const { validation, handleCheckChange, typeEdition } = props;

    const dispatch = useDispatch();
    const [isEdit, setIsEdit] = useState(props?.isEdit);
    const [propertyL, setPropertyL] = useState(props.property);
    const [catStatusProperty, setCatStatusProperty] = useState(
        [{id:'Bueno',name:'Bueno'},{id:'Regular',name:'Regular'},{id:'Malo',name:'Malo'}]
    );
    const [catDocuments, setCatDocuments] = useState(
        [{id:'ACTA DE CABILDO',name:'ACTA DE CABILDO'},{id:'TITULO DE PROPIEDAD',name:'TITULO DE PROPIEDAD'},
            {id:'ESCRITURAS',name:'ESCRITURAS'},{id:'ACTA DE DONACIÓN',name:'ACTA DE DONACIÓN'},
        {id:'FACTURA',name:'FACTURA'},{id:'OTROS',name:'OTROS'}]);
    const { typeProperties, areas, propertySaved, typePropertiesLevel3 } = useSelector(state => ({
        typeProperties: state.TypePropertyReducer.typePropertiesBySelect,
        areas: state.ConfigInit.areas,
        propertySaved: state.PropertyReducer.propertySaved,
        typePropertiesLevel3: state.TypePropertyReducer.typePropertiesLevel3
    }));

    useEffect(() => {
        dispatch(actionGetTypePropertiesSelect({active:true, typePropertyParent:null, typePropertyLevel:1}));
         dispatch(getAreas({for_: 'inventory'}));
    }, []);

    useEffect(()=>{
        if(validation.values.type_property) {
            dispatch(actionGetTypePropertiesSelect({active:true, typePropertyParent:validation.values.type_property, typePropertyLevel:1,getLevel3:true})); 
        }
    },[validation.values.type_property])

    useEffect(()=>{
        if(propertySaved) {
            //validation.resetForm();
        }
    },[propertySaved]);

    useEffect (()=>{
        return () => {  
            //validation.resetForm();
            dispatch (setPropertySaved(false));
            //setIsEdit(false)
        }
    },[props?.property, props?.isEdit])


    return (
        <React.Fragment>
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <Row>
                    <Col className="col-6">
                        <SelectCustom
                            lblInput="Tipo de Bien"
                            inputName="type_property"
                            inputPlaceholder="Ingrese el tipo de bien"
                            validation={validation}
                            data={typeProperties}
                        />  
                        <SelectCustom
                            lblInput="Rubro"
                            inputName="type_property3"
                            inputPlaceholder="Ingrese el rubro"
                            validation={validation}
                            data={typePropertiesLevel3}
                        />
                        
                        <InputCustom
                            lblInput="Concepto"
                            inputName="concept"
                            inputType="text"
                            inputPlaceholder="Ingrese el concepto"
                            validation={validation}
                        />
                        <InputCustom
                            lblInput="Descripción"
                            inputName="description"
                            inputType="textarea"
                            inputPlaceholder="Ingrese la descripción"
                            validation={validation}
                           
                        />

                        <InputCustom
                            lblInput="Cantidad"
                            inputName="quantity"
                            inputType="text"
                            inputPlaceholder="Ingrese la cantidad"
                            validation={validation}
                        />

                        <InputCustom
                            lblInput="Marca"
                            inputName="trademark"
                            inputType="text"
                            inputPlaceholder="Ingrese la marca"
                            validation={validation}
                        />

                        <InputCustom
                            lblInput="Número de Serie"
                            inputName="serial_number"
                            inputType="text"
                            inputPlaceholder="Ingrese el número de serie"
                            validation={validation}
                        />

                        {
                            ['36', '37', '38', '42', '43'].includes(validation.values.type_property3) && (
                                <InputCustom
                                    lblInput="Placas"
                                    inputName="car_registration_number"
                                    inputType="text"
                                    inputPlaceholder="Ingrese las placas de vehículo"
                                    validation={validation}
                                />
                            )
                        }
                        
                    </Col>

                    <Col className="col-6">
                        <InputCustom
                            lblInput="Costo de adquisición"
                            inputName="value"
                            inputType="number"
                            inputPlaceholder="Ingrese el valor"
                            validation={validation}
                        />
                        <SelectCustom
                            lblInput="Documento" data={catDocuments}
                            inputName="document"
                            inputType="text"
                            inputPlaceholder="Ingrese el documento"
                            validation={validation}
                        />

                        {
                            validation.values.document && validation.values.document==='OTROS' && (
                                <InputCustom
                                    lblInput="Especificar documento"
                                    inputName="document_other"
                                    inputType="text"
                                    inputPlaceholder="Ingrese el tipo de documento"
                                    validation={validation}
                                />
                            )
                        }
                        <InputCustom
                            lblInput="Número de Documento"
                            inputName="num_document"
                            inputType="text"
                            inputPlaceholder="Ingrese el número de documento"
                            validation={validation}
                        />
                        <InputCustom
                            lblInput="Ubicación"
                            inputName="location"
                            inputType="text"
                            inputPlaceholder="Ingrese la ubicación"
                            validation={validation}
                        />
                        {typeEdition!=="Discontinued" && (
                        <><SelectCustom
                            lblInput="Condición Física"
                            inputName="physical_condition"
                            inputType="select" data={catStatusProperty}
                            inputPlaceholder="Ingrese la condición física"
                            validation={validation}
                        />
                        <InputCustom
                            lblInput="Observaciones"
                            inputName="observations"
                            inputType="textarea"
                            inputPlaceholder="Ingrese las observaciones"
                            validation={validation}
                        /></>)}

                        <InputCustom
                            lblInput="Nombre del resguardante"
                            inputName="name_guardian"
                            inputType="text"
                            inputPlaceholder="Ingrese el nombre del resguardante"
                            validation={validation}
                        />

                        <SelectCustom
                            lblInput="Area"
                            inputName="area"
                            inputType="text"
                            inputPlaceholder="Ingrese la area"
                            validation={validation}
                            data={areas}
                        />                        
                    </Col>
                    {typeEdition==="Discontinued" && (<Col className="col-12">
                        <><InputCustom
                            lblInput="Justificación de baja"
                            inputName="justification_discontinuation"
                            inputType="textarea"
                            inputPlaceholder="Ingrese la justificación"
                            validation={validation}
                        />
                        <InputCustom
                            lblInput="Observaciones"
                            inputName="observations"
                            inputType="textarea"
                            inputPlaceholder="Ingrese las observaciones"
                            validation={validation}
                        /></>
                    </Col>)}
                </Row>
                
            </Form>
        </React.Fragment>
    )
}

export default FormNewProperty